import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityPagesAPI } from './pages-api'

export class VerifyPasswordless {
    public static DOM = {
        class: {
            pageVerifyPasswordless: 'page-verify-passwordless'
        }
    }

    private tokenQueryStringKey = 'vtoken'

    /**
     * Verifies the access token. If token is valid, redirect to the SSO page
     */
    public async init() {
        const verifyPasswordlessPage = document.querySelector(`.${VerifyPasswordless.DOM.class.pageVerifyPasswordless}`)
        const urlParams = new URLSearchParams(window.location.search)

        if (verifyPasswordlessPage) {
            if (urlParams.has(this.tokenQueryStringKey)) {
                const token = urlParams.get(this.tokenQueryStringKey)
                try {
                    // check if the token is valid
                    const response = await IdentityPagesAPI.verifyPasswordlessLogin({ vtoken: token })

                    const accessToken = response.access_token
                    if (accessToken && sessionStorage && localStorage) {
                        localStorage.setItem(Store.LR_TOKEN_KEY, accessToken)

                        const redirect = LoginService.getRedirectUrl(window.location.origin, accessToken)
                        sessionStorage.removeItem(Store.PASSWORDLESS_EMAIL_ADDRESS)
                        LoginService.setSessionStorage(urlParams)

                        logger('debug', 'Verify passwordless email link success')
                        // Redirect to SSO page that will later redirect the user to the `redirect`
                        window.location.replace(LoginService.getSSORedirectURL(accessToken, redirect))
                    } else {
                        logger('error', 'Passwordless email link is invalid')
                        window.location.replace('/verify-passwordless-error/')
                    }
                } catch(err) {
                    logger('error', 'Unable to verify passwordless email link', err)
                    window.location.replace('/verify-passwordless-error/')
                }
            } else {
                logger('error', 'Missing vtoken parameter in passwordless email link')
                window.location.replace('/verify-passwordless-error/')
            }
        }
    }
}
